import { render, staticRenderFns } from "./PathologyCheckup.vue?vue&type=template&id=5a3160da&scoped=true"
import script from "./PathologyCheckup.vue?vue&type=script&lang=js"
export * from "./PathologyCheckup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3160da",
  null
  
)

export default component.exports